import { render, staticRenderFns } from "./CreateEditClient.vue?vue&type=template&id=a6e1820c&scoped=true"
import script from "./CreateEditClient.vue?vue&type=script&lang=js"
export * from "./CreateEditClient.vue?vue&type=script&lang=js"
import style0 from "./CreateEditClient.vue?vue&type=style&index=0&id=a6e1820c&prod&scoped=true&lang=css"
import style1 from "./CreateEditClient.vue?vue&type=style&index=1&id=a6e1820c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e1820c",
  null
  
)

export default component.exports